// extracted by mini-css-extract-plugin
module.exports = {"downloadBtn":"styles_downloadBtn__2-cQ6"};